export default function ConfirmModal({ message, onConfirm, onCancel }) {
  return (
    <div className="modal-overlay" onClick={onCancel}>
      <div className="modal-content confirm-modal" onClick={(e) => e.stopPropagation()}>
        <p className="confirm-modal-message">{message}</p>
        <div className="confirm-modal-actions">
          <button className="btn-ghost-sm" onClick={onCancel}>Cancel</button>
          <button className="btn-danger-sm" onClick={onConfirm}>Delete</button>
        </div>
      </div>
    </div>
  );
}
